import React from "react"
import PropTypes from "prop-types"
import { connect } from "react-redux"
import { removeRow, removeResourceTableRow } from "sheets/sheet-action-creators"
import { indexCellConnection } from "sheets/selectors/column-selectors"
// components
import { Cell } from "fixed-data-table-2"
import RemoveRowButton from "sheets/components/RemoveRowButton"
// helpers
import classNames from "classnames"
import isFeatureEnabled from "shared/featureflags/helperFunctions"

export const IndexCell = ({
    canRemoveRows,
    datumId,
    evenCell,
    id,
    isResourceTable,
    oddCell,
    patchSavedSearch,
    removeRowNetworkRequestActionCreator, // optional, for resource tables
    rowResource,
    usesParentChildCell,
    rowIndex,
    rows,
    swalConfig,
    ...props
}) => (
    <Cell
        {...props}
        className={classNames("index-cell", {
            "even-cell": !isResourceTable && usesParentChildCell,
            "parent-child": usesParentChildCell,
            "can-remove-rows": canRemoveRows,
        })}
    >
        <span className="row-index">{rowIndex + 1}</span>
        <RemoveRowButton
            datumId={datumId}
            id={id}
            rowResource={rowResource}
            rowIndex={rowIndex}
            rows={rows}
            removeRow={isResourceTable ? props.removeResourceTableRow : props.removeRow}
            optionalActionCreator={removeRowNetworkRequestActionCreator}
            swalConfig={swalConfig}
            dataPlumId="sheets-minus-sign"
        />
    </Cell>
)

IndexCell.propTypes = {
    removeResourceTableRow: PropTypes.func.isRequired,
    removeRow: PropTypes.func.isRequired,
    canRemoveRows: PropTypes.bool.isRequired,
}

export default connect(indexCellConnection, { removeRow, removeResourceTableRow })(IndexCell)
